import React from 'react';

import { useIntl } from 'react-intl-next';

import { Box, Flex, xcss } from '@atlaskit/primitives';

import { VALUE_WIDTH } from '../constants';
import { Row } from '../index';

import { DATE_WIDTH, TIME_WIDTH } from './constants';
import { type DateTimeProps } from './types';
import { infoText, labelText } from './utils';

const dateStyles = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${DATE_WIDTH}px`,
});

const timeStyles = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${TIME_WIDTH}px`,
});

const infoStyles = xcss({
	color: 'color.text',
	fontWeight: 'font.weight.regular',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${VALUE_WIDTH}px`,
});

const DateTime = ({ epoch, isTrueTime, variant }: DateTimeProps) => {
	const intlApi = useIntl();

	const date = intlApi.formatDate(epoch, {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		timeZone: 'UTC',
	});

	const time = intlApi.formatTime(epoch, {
		hour: 'numeric',
		minute: 'numeric',
		timeZone: 'UTC',
	});

	return (
		<Row variant="inline" label={labelText(intlApi)[variant]}>
			{isTrueTime ? (
				<Flex columnGap="space.050" alignItems="center" xcss={infoStyles}>
					<Box as="span" xcss={dateStyles}>
						{date}
					</Box>
					<Box as="span" xcss={timeStyles}>
						{time}
					</Box>
				</Flex>
			) : (
				infoText(intlApi)[variant]
			)}
		</Row>
	);
};

export { DateTime };
